export const CoursesArray = [
  "Engineering",
  "Medical",
  "Law",
  "Design",
  "MBA",
  "Others",
];
